import script from "./NewsFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsFeed.vue?vue&type=script&setup=true&lang=ts"

import "./NewsFeed.vue?vue&type=style&index=0&id=67d958cc&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d958cc"]])

export default __exports__